import "../scss/index.scss";
import "swiper/css";
import "swiper/css/pagination";

import * as bootstrap from "bootstrap";
import initCarousel from "./components/Carousel/initCarouselHero";
import initCarouselAmbassadors from "./components/Carousel/initCarouselAmbassadors";
import initCarouselRecommendedProducts from "./components/Carousel/initCarouselRecommendedProducts";
import initCarouselReels from "./components/Carousel/initCarouselReels";
import initStickyHeader from "./components/Header/stickyHeader";
import initMobileMenu from "./components/Header/mobileMenu";
import initPostArchiveVanilla from "./components/PostArchive/initPostArchiveVanilla";
import initProductArchiveVanilla from "./components/ProductArchive/initProductArchiveVanilla";
// Removed product page variant switching functionality

// Initialize components when DOM is ready – each in its own try/catch
// so one failure doesn't block the rest (critical for static export where
// some page-specific elements may be absent).
function safeInit(name, fn) {
  try {
    fn();
  } catch (err) {
    console.error(`[theme] ${name} init failed:`, err);
  }
}

document.addEventListener("DOMContentLoaded", function () {
  safeInit("Carousel",                   initCarousel);
  safeInit("CarouselAmbassadors",        initCarouselAmbassadors);
  safeInit("CarouselRecommendedProducts",initCarouselRecommendedProducts);
  safeInit("CarouselReels",             initCarouselReels);
  safeInit("StickyHeader",               initStickyHeader);
  safeInit("MobileMenu",                 initMobileMenu);
  safeInit("PostArchiveVanilla",         initPostArchiveVanilla);
  safeInit("ProductArchiveVanilla",      initProductArchiveVanilla);
});

// When variant is changed via no-reload switcher, re-init any components that rely on DOM
document.addEventListener('variant:changed', () => {
  try {
    // Re-initialize carousels if needed (mobile gallery pagination)
    initCarouselRecommendedProducts();
  } catch (e) {
    console.warn('Variant change re-init failed', e);
  }
});
